
import { ResultData, ValidateResult } from "@nt-portal/common-sdk";
import { ETenderProfile, ETenderProfileService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";

export interface ETenderProfileOptions extends ControllerOptions<ETenderProfile> {

}

export const createETenderProfile = (obj: Partial<ETenderProfile>) => {
    let item: ETenderProfile = {
        ...obj,
        name: obj.name || "",
        createdBy: obj.createdBy || "",
    }
    return item;
}


export class ClientETenderProfileService extends BaseClientService implements DataController<ETenderProfile> {

    private _service: ETenderProfileService;


    constructor() {
        super();
        this._service = new ETenderProfileService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: ETenderProfileOptions): Promise<ResultData<ETenderProfile>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: ETenderProfileOptions): Promise<ResultData<ETenderProfile>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: ETenderProfileOptions): Promise<ETenderProfile | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: ETenderProfileOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: ETenderProfileOptions): Promise<ETenderProfile | ETenderProfile[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: ETenderProfileOptions): Promise<ETenderProfile | ETenderProfile[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    // public async import(options: ETenderProfileOptions): Promise<any> {
    //     if (options.file)
    //         return await this._service.importExcel(options.file, this.token);
    // }

    // public async export(options: ETenderProfileOptions): Promise<any> {
    //     let fetchParams = this.buildLookupFetchParams(options);
    //     return await this._service.export(this.token, fetchParams, options.filter);
    // }

     
}